import { render } from "./FishGame.vue?vue&type=template&id=dc2bdc9c"
import script from "./FishGame.vue?vue&type=script&lang=js"
export * from "./FishGame.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__